import React from 'react';
import { CreditCard, MessageCircle, Rocket } from 'lucide-react';
import { MiniForm } from '@/components/shared/Forms';

export default function VenddiCtaFinal() {
  return (
    <div className="relative overflow-hidden bg-[#050E1F] text-white">
      <div className="absolute inset-0 noise-texture opacity-40" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-[#38BDF8]/15 blur-3xl rounded-full" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 mb-5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#38BDF8] bg-[#38BDF8]/10 border border-[#38BDF8]/20 rounded-full">
          <Rocket className="w-3.5 h-3.5" />EMPIEZA HOY
        </div>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] mb-5" style={{ fontFamily: 'Syne,sans-serif' }}>
          Vender más.<br /><span className="text-[#38BDF8]">Con menos fricción.</span>
        </h2>
        <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto mb-8">
          En 5-7 días hábiles tus kioscos están operando con Venddi. Sin CAPEX. Factura mensual en UF. Kian supervisando desde el día 1.
        </p>
        <div className="max-w-md mx-auto p-6 rounded-2xl bg-white/5 backdrop-blur border border-white/10">
          <MiniForm sourcePage="/software/venddi" />
        </div>
        <div className="flex flex-wrap justify-center gap-3 mt-6">
          <a href="#planes" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-[#38BDF8] text-[#0A2540] text-sm font-bold hover:bg-sky-300 shadow-lg transition-all">
            <CreditCard className="w-4 h-4" />Ver planes desde 1 UF
          </a>
          <a href="https://wa.me/56975294340?text=Hola,%20me%20interesa%20Venddi%20POS" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl text-emerald-400 border border-emerald-400/30 text-sm font-bold hover:bg-emerald-400/10 transition-all">
            <MessageCircle className="w-4 h-4" />WhatsApp directo
          </a>
        </div>
      </div>
    </div>
  );
}
